<template>
  <div class="main">
    <el-form :inline="true">
      <el-form-item label="简历状态：">
        <el-select v-model="query.status">
          <el-option
            v-for="(val, key) in $store.state.resumeStatus"
            :key="key"
            :label="val"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getResumes">搜索</el-button>
      </el-form-item>
    </el-form>
    <ul class="resume">
      <li v-for="item in resumes" :key="item.apply_id">
        <div class="left-content">
          <img src="../../../assets/img/resume/profile-photo.png" alt />
          <div class="base-info">
            <div class="line-1">
              <strong>{{item.student_name}}</strong>
              <span style="color: #0bb5ff;">（简历状态：{{item.resumeStatus}}）</span>
              <span style="color: #8fd96b;" v-if="item.comment">（备注：{{item.comment}}）</span>
            </div>
            <div class="line-2">
              <span>{{item.created_at}}</span>
              <span>{{item.school_name}}</span>
              <span>{{item.major_name}}</span>
              <span>{{item.graduation_year}}年毕业</span>
              <span>{{item.phone}}</span>
            </div>
          </div>
        </div>
        <div class="right-content">
          <!--          <el-button :disabled="item.called === 'yes'" type="primary" @click="editCalled(item.id)">-->
          <!--            {{item.called === 'no' ? '联系标记' : '已联系'}}-->
          <!--          </el-button>-->
          <el-button
            type="primary"
            style="padding: 10px 5px;"
            @click="editStatus(item)"
            size="mini"
          >编辑简历状态</el-button>
          <el-button
            type="primary"
            style="padding: 10px 5px;"
            @click="editComment(item.id)"
            size="mini"
          >备注</el-button>
          <el-button
            type="info"
            style="padding: 10px 5px;"
            @click="look(item.student_id,item.student_name,item.school_id)"
            size="mini"
          >查看</el-button>
        </div>
      </li>
    </ul>
    <div v-if="total == 0" class="noData">暂无简历投递！</div>
    <Pagination
      ref="pagination"
      :total="total"
      @size-change="getResumes"
      @current-change="getResumes"
    />

    <el-dialog :visible="editDialogVisible" title="编辑简历状态" :before-close="cancel">
      <el-radio v-model="row.status" label="apply">待沟通</el-radio>
      <el-radio v-model="row.status" label="contact">已沟通</el-radio>
      <el-radio v-model="row.status" label="no_interest">暂无意向</el-radio>
      <el-radio v-model="row.status" label="no_match">不合适</el-radio>
      <el-radio v-model="row.status" label="auditon">已面试</el-radio>
      <el-radio v-model="row.status" label="employed">录用</el-radio>
      <el-radio v-model="row.status" label="entry">入职</el-radio>
      <el-row style="margin-top: 50px;">
        <el-col :offset="16">
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 个人简历弹框 -->
    <el-dialog :title="selfResume.name+'的简历'" :visible.sync="detailDialogVisible" width="500px">
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">姓名：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">学校：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.school_name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">专业：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.major_name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">毕业年份：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.graduation_Year }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">性别：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.gender == 1?'男':'女' }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">民族：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.nation }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">籍贯：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.native_province + selfResume.native_city }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">出生日期：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.birthday }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">联系电话：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.phone }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">联系QQ：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.qq }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">当前所在城市：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.current_province + selfResume.current_city }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望城市1：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_city1 }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望城市2：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_city2 }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望工作岗位：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_job }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望最低薪资：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_low }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望最高薪资：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_high }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">校内职务：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.post }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">获得的资格证书：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.certificate }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">技能大赛获奖说明：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.prise }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">校内其他获奖荣誉：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.other_prise }}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination"; // 分页组件
import formatter from "@/assets/js/mixins/formatter"; // 公用函数

let edit = {
  data: {
    editDialogVisible: false,
    row: {},
    detailDialogVisible: false, // 详情对话框是否显示
    selfResume: {
      birthday: "",
      certificate: "",
      current_city: "",
      current_province: "",
      expect_city1: "",
      expect_city2: "",
      expect_city3: "",
      expect_high: "",
      expect_job: "",
      expect_low: "",
      expect_province1: "",
      expect_province2: "",
      expect_province3: "",
      family: "",
      family_phone: "",
      gender: 1,
      graduation_Year: "",
      major_name: "",
      name: "",
      nation: "",
      native_city: "",
      native_province: "",
      other_prise: "",
      phone: "",
      post: "",
      prise: "",
      qq: "",
      school_name: ""
    } //个人简历
  },
  methods: {
    editStatus(row) {
      this.row = Object.assign({}, row);
      this.editDialogVisible = true;
    },
    submit() {
      this.$confirm("确认修改？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(async () => {
        let res = await this.$api.job.markResume(this.row.id, {
          status: this.row.status
        });
        if (res.code === 0) {
          this.$message.success("修改成功！");
          this.getResumes();
          this.cancel();
        }
      });
    },
    cancel() {
      this.editDialogVisible = false;
    }
  }
};

export default {
  components: {
    Pagination
  },
  mixins: [formatter],
  data() {
    return {
      query: {
        // 查询条件
        channel: "", // 简历来源
        apply_status: "", // 投递状态
        school_name: "" // 学校名称
      },
      resumes: [], // 简历
      total: 0,
      ...edit.data
    };
  },
  mounted() {
    this.getResumes();
  },
  methods: {
    async getResumes() {
      let params = this.delNullVal(this.query);
      params.page = this.$refs.pagination.page;
      params.page_size = this.$refs.pagination.page_size;
      let res = await this.$api.job.resumesFromSignJob(params);
      if (res.code === 0) {
        this.resumes = res.data.items.map(item => {
          item.resumeStatus = this.$store.state.resumeStatus[item.status];
          return item;
        });
        this.total = res.data.count;
      }
    },
    async editCalled(applyId) {
      let params = {
        called: "no"
      };
      let res = await this.$api.job.markResume(applyId, params);
      if (res.code === 0) {
        this.$message.success("成功！");
        this.getResumes();
      }
    },
    async look(stuId, name, schoolId) {
      if (!this.$store.state.paymentStatus) {
        this.$confirm(
          '<p style="color:#606266">未认证状态下不能查看简历，是否马上去认证</p>',
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning"
          }
        )
          .then(() => {
            this.auth(schoolId);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消认证"
            });
          });
        return;
      }
      let params = {
        student_id: stuId,
        student_name: name,
        school_id: schoolId
      };
      let res = await this.$api.job.getStuResume(params);
      if (res.code === 0) {
        // this.$message.success("成功！");
        // this.getResumes();
        console.log(res);
        let data = res.data;
        this.selfResume.birthday = data.birthday;
        this.selfResume.certificate = data.certificate;
        this.selfResume.current_city = data.current_city;
        this.selfResume.current_province = data.current_province;
        this.selfResume.expect_city1 = data.expect_city1;
        this.selfResume.expect_city2 = data.expect_city2;
        this.selfResume.expect_city3 = data.expect_city3;
        this.selfResume.expect_high = data.expect_high;
        this.selfResume.expect_job = data.expect_job;
        this.selfResume.expect_low = data.expect_low;
        this.selfResume.expect_province1 = data.expect_province1;
        this.selfResume.expect_province2 = data.expect_province2;
        this.selfResume.expect_province3 = data.expect_province3;
        this.selfResume.family = data.family;
        this.selfResume.family_phone = data.family_phone;
        this.selfResume.gender = data.gender;
        this.selfResume.graduation_Year = data.graduation_Year;
        this.selfResume.major_name = data.major_name;
        this.selfResume.name = data.name;
        this.selfResume.nation = data.nation;
        this.selfResume.native_city = data.native_city;
        this.selfResume.native_province = data.native_province;
        this.selfResume.other_prise = data.other_prise;
        this.selfResume.phone = data.phone;
        this.selfResume.post = data.post;
        this.selfResume.prise = data.prise;
        this.selfResume.qq = data.qq;
        this.selfResume.school_name = data.school_name;

        this.detailDialogVisible = true;
      }
    },
    async editComment(applyId) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(async ({ value }) => {
        let res = await this.$api.job.markResume(applyId, { comment: value });
        if (res.code === 0) {
          this.$message.success("成功！");
          this.getResumes();
        }
      });
    },
    ...edit.methods
  }
};
</script>

<style lang="scss" scoped>
.main {
  .resume {
    margin-top: 24px;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 1px 16px 0px #d2d2d2;
      border-radius: 24px;
      padding: 24px 16px;
      color: #929292;
      margin-bottom: 20px;

      .left-content {
        display: flex;
        align-items: center;

        img {
          width: 57px;
          height: 57px;
        }

        .base-info {
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          color: #929292;

          .line-1 {
            strong {
              color: #000;
              margin-right: 20px;
            }
          }

          .line-2 {
            span:not(:last-child) {
              &::after {
                content: "";
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #929292;
                margin: 0 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }

      .right-content {
        width: 200px;
      }
    }
  }
  .noData {
    text-align: center;
    height: 200px;
    line-height: 200px;
  }
}
</style>